import React, { useEffect, useMemo, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { FormControlLabel, Grid, Popover, Radio, RadioGroup } from '@mui/material'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import i18n from 'simple-react-i18n'
import { isNil } from 'lodash'
import { ChipLabel } from './ChartOptionsChip'
import { StyledFieldSet, StyledLegend } from '../StyledElements'
import { ButtonMUI } from '../styled/Buttons'
import useSandreList from '../../utils/customHook/useSandreList'
import { SANDRE } from '../../referencial/constants/ReferencialConstants'
import { getGmtLabel, getGmtSuffix, getSelectableTempRefs } from '../../utils/TempRefUtil'

const STATION_TEMP_REF = 'STATION'

const ChartTempRefChip = ({
    tempRef,
    offsetHours,
    stationOffsetHours,
    stationTempRefs = [],
    onChange = () => {},
}) => {
    const refTempList = useSandreList(SANDRE.REF_TEMPORELLES)
    const anchorEl = useRef()
    const [openModal, setOpenModal] = useState(false)
    const [selected, setSelected] = useState(isNil(tempRef) ? STATION_TEMP_REF : `${tempRef}`)

    const selectableTempRefs = useMemo(() => getSelectableTempRefs(refTempList), [refTempList])

    useEffect(() => setSelected(isNil(tempRef) ? STATION_TEMP_REF : `${tempRef}`), [tempRef])

    const onSave = () => {
        setOpenModal(false)
        onChange(selected === STATION_TEMP_REF ? undefined : parseInt(selected))
    }

    if (!stationTempRefs.length || !selectableTempRefs.length) {
        return null
    }

    const chipLabel = isNil(tempRef) ? `${i18n.station}${getGmtSuffix(stationOffsetHours)}` : getGmtLabel(offsetHours)

    return (
        <Grid>
            <ChipLabel
                label={chipLabel}
                startIcon={<AccessTimeIcon sx={{ height: 20, width: 20 }} />}
                onClick={() => setOpenModal(prev => !prev)}
                ref={anchorEl}
                isOpen={openModal}
                sx={{ height: '2.7rem' }}
            />
            <Popover
                open={openModal}
                anchorEl={anchorEl.current}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: '0 5px 5px 5px',
                            width: 340,
                        },
                    },
                }}
                onClose={() => setOpenModal(false)}
            >
                <Grid sx={{ border: '2px solid rgba(53, 96, 159, 1)', padding: '10px' }}>
                    <StyledFieldSet>
                        <StyledLegend>{i18n.tempRef}</StyledLegend>
                        <RadioGroup
                            value={selected}
                            onChange={event => setSelected(event.target.value)}
                            sx={{ padding: '5px 10px' }}
                        >
                            <FormControlLabel
                                value={STATION_TEMP_REF}
                                control={<Radio size='small' />}
                                label={`${i18n.stationTempRef}${getGmtSuffix(stationOffsetHours)}`}
                            />
                            {selectableTempRefs.map(sandreCode => (
                                <FormControlLabel
                                    key={sandreCode.code}
                                    value={`${sandreCode.code}`}
                                    control={<Radio size='small' />}
                                    label={sandreCode.name}
                                />
                            ))}
                        </RadioGroup>
                    </StyledFieldSet>
                    <Grid size={12} sx={{ paddingTop: '10px' }}>
                        <ButtonMUI
                            fullWidth
                            variant={'contained'}
                            onClick={onSave}
                        >
                            {i18n.toLoad}
                        </ButtonMUI>
                    </Grid>
                </Grid>
            </Popover>
        </Grid>
    )
}

ChartTempRefChip.propTypes = {
    tempRef: PropTypes.number,
    offsetHours: PropTypes.number,
    stationOffsetHours: PropTypes.number,
    stationTempRefs: PropTypes.arrayOf(PropTypes.shape({ tempRef: PropTypes.number })),
    onChange: PropTypes.func,
}

export default ChartTempRefChip